import Config from "./Config";

/**
 * Prepends API base URL if path is relative.
 * @param {string} path - The relative or absolute path
 * @returns {string} Full URL
 */
export function buildUrl(path = "") {
    if (!path) return "";
    if (/^https?:\/\//i.test(path)) return path; // already absolute
    const normalized = path.startsWith("/") ? path : `/${path}`;
    return `${Config.API.API_BASE_URL}${normalized}`;
}